import { call, put } from 'redux-saga/effects';
import {
    getClientCredentials,
    setClientBrands
} from './client-credentials.backend';
import {
    fetchClientCredentialsFail,
    fetchClientCredentialsSuccess,
    setClientBrandsFail,
    setClientBrandsSuccess
} from './actions';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../shared/toast/redux/actions';

export function* fetchClientCredentialsSaga() {
    try {
        const response = yield call(getClientCredentials);
        yield put(fetchClientCredentialsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchClientCredentialsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* setClientBrandsSaga(action) {
    const { id, brandIds } = action.payload;

    try {
        const response = yield call(setClientBrands, id, brandIds);
        yield put(setClientBrandsSuccess(response.data));
        yield put(
            setSuccessToast(
                makeSuccessPayload(
                    `The brands of ${response.data.email} were changed. It takes effect on the next event it sends.`
                )
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(setClientBrandsFail({ id, error: formattedError }));
        yield put(setErrorToast(formattedError));
    }
}
